import React from 'react';
import { connect } from 'react-redux';

import {
  sGetUnseenNotifications,
  sGetNotificationsFetching,
} from '../../../../store/reducers/notifications';

import { isProduction } from '../../../../config';
import localStorage from '../../../../utils/localStorage';
import { ACTIVE_PROPERTY_UID } from '../../../../constants';
import Sidebar from '../../../../components/desktop/Sidebar';
import { privateNavbarMenu } from '../../../../structure/menu';
import { sGetPropertyByBoligmappaNumber } from '../../../../store/reducers/properties';
import { useActiveProperty } from '../../../../store/hooks';
import { getPropertyType } from '../../../../utils/properties';

const DesktopSidebar = ({
  unseenNotifications,
  fetchingNotifications,
  getPropertyByBoligmappaNumber,
  accessRequests,
}) => {
  const { property } = useActiveProperty();
  const unseenNotificationsCount = unseenNotifications.length;
  const activePropertyId = localStorage.get(ACTIVE_PROPERTY_UID);
  const activeProperty = getPropertyByBoligmappaNumber(activePropertyId);
  const isPublicProperty = activeProperty && activeProperty.owned;

  const items = privateNavbarMenu
    .filter((menuItem) => !menuItem.mobileOnly && !menuItem.isHide)
    .filter(({ experimental }) => {
      const isNotInProduction = !isProduction();
      if (isNotInProduction) return true;
      return !experimental;
    })
    .filter(
      (menuItem) =>
        !(menuItem.hideInPrivateProperty && !isPublicProperty) &&
        !(
          menuItem.hideOnLands &&
          getPropertyType(property) === 'Eiendom/tomt uten bygning'
        ) &&
        !(
          menuItem.hideOnGarageBuilding &&
          getPropertyType(property) === 'GARASJEUTHUS ANNEKS TIL BOLIG'
        )
    )
    .map(({ link, icon, title, isNotification, isNew, ...properties }) => ({
      link,
      icon,
      title,
      isNotification,
      badgeContent:
        isNotification && !fetchingNotifications
          ? unseenNotificationsCount
          : null,
      isNew,
      ...properties,
    }));

  return <Sidebar items={items} accessRequests={accessRequests} />;
};

const mapStateToProps = (state) => ({
  unseenNotifications: sGetUnseenNotifications(state),
  fetchingNotifications: sGetNotificationsFetching(state),
  getPropertyByBoligmappaNumber: (boligmappaNumber) =>
    sGetPropertyByBoligmappaNumber(state, boligmappaNumber),
});

export default connect(mapStateToProps)(DesktopSidebar);
